import { normalizePhoneNumber } from "@/lib/phoneHelpers";

type PhoneSearchHit = {
  phone?: string;
  phones?: string[];
};

export const formatPhoneQueryWithDashes = (phone: string): string => {
  const normalizedPhone = normalizePhoneNumber(phone);

  if (normalizedPhone.length !== 10) {
    return phone;
  }

  return `${normalizedPhone.slice(0, 3)}-${normalizedPhone.slice(3, 6)}-${normalizedPhone.slice(6)}`;
};

export const hitHasPhoneNumber = (hit: PhoneSearchHit, phone: string): boolean => {
  const normalizedPhone = normalizePhoneNumber(phone);
  const phoneValues = [hit.phone, ...(hit.phones ?? [])];
  return phoneValues.some((phoneValue) => !!phoneValue && normalizePhoneNumber(phoneValue) === normalizedPhone);
};
